"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var ButtomComponent_1 = __importDefault(require("../../../components/Form/ButtomComponent"));
var components_1 = require("../../../components");
var containers_1 = require("../../../containers");
var hooks_1 = require("../../../hooks");
var styles_1 = require("../../../styles");
var utilities_1 = require("../../../utilities");
function MerchantList() {
    var _a, _b;
    var _c = (0, react_router_dom_1.useSearchParams)(), searchParams = _c[0], setSearchParams = _c[1];
    var disclosureMerchantDetailDrawer = (0, hooks_1.useDisclosure)();
    var headerContainer = (0, react_1.useRef)(null);
    var termSearch = searchParams.get('term');
    var _d = (0, hooks_1.useFetchMerchantsAdmin)(), merchantsData = _d.data, refetch = _d.refetch, isLoading = _d.isLoading, isFetching = _d.isFetching;
    var handleShowDetail = function (item) {
        searchParams.set('merchantIdentifier', item.id);
        setSearchParams(searchParams);
        disclosureMerchantDetailDrawer.onOpen();
    };
    var handleCloseMerchantDetailDrawer = function () {
        searchParams.delete('merchantIdentifier');
        searchParams.delete('merchantTransactions');
        setSearchParams(searchParams);
        disclosureMerchantDetailDrawer.onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.WrapperPage, { children: [(0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ elevation: 0, sx: { marginBottom: '30px' }, ref: headerContainer }, { children: [(0, jsx_runtime_1.jsx)(components_1.SectionTitle, { title: "Clientes B2B", renderRight: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Refrescar lista" }, { children: (0, jsx_runtime_1.jsx)(ButtomComponent_1.default.Filter, __assign({ variant: "outlined", color: "inherit", onClick: function () { return refetch(); } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Refresh, {}) })) })) }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                            display: 'grid',
                            gap: '5px',
                            gridTemplateColumns: '1fr',
                        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '10px',
                                } }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                                        width: { xs: '100%', sm: '50%' },
                                    } }, { children: (0, jsx_runtime_1.jsx)(components_1.InputSearch, { placeholder: "Buscar cliente B2B" }) })) })), (0, jsx_runtime_1.jsx)(styles_1.HelperText, { children: "Buscar por: Nombre del Cliente B2B." })] })), (0, jsx_runtime_1.jsx)(containers_1.HelperSearchOrFilterContainer, { search: termSearch !== null && termSearch !== void 0 ? termSearch : '' })] })), (0, jsx_runtime_1.jsxs)(material_1.Paper, { children: [(0, jsx_runtime_1.jsx)(components_1.TableComponent, { variant: "normal", isLoading: isLoading || isFetching, rows: (_a = merchantsData === null || merchantsData === void 0 ? void 0 : merchantsData.data) !== null && _a !== void 0 ? _a : [], keyExtractor: function (item) { return item.id; }, stickyHeader: true, maxHeight: "calc(100vh - ".concat(headerContainer.current &&
                            ((_b = headerContainer.current) === null || _b === void 0 ? void 0 : _b.clientHeight) + 240, "px)"), columns: [
                            {
                                label: 'Cliente B2B',
                                field: 'company_name',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.company_name;
                                },
                            },
                            {
                                label: 'Código del Cliente B2B',
                                field: 'code_client',
                                align: 'right',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.code_client;
                                },
                            },
                            // {
                            //   label: 'Total de Saldo',
                            //   field: 'merchant_wallet',
                            //   align: 'right',
                            //   type: 'text',
                            //   valueGetter: ({ row }) => amountFormatByCurrencyCode(row.merchant_wallet.balance, row.merchant_wallet.currency_code),
                            // },
                            {
                                label: 'Estado',
                                field: 'status',
                                align: 'center',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsx)(containers_1.ChipStatusContainer, { status: row.status }));
                                },
                            },
                            {
                                label: 'Fecha de Registro',
                                field: 'created_at',
                                align: 'left',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return (0, utilities_1.formatDate)({ date: row.created_at });
                                },
                            },
                            {
                                label: 'Opciones',
                                align: 'right',
                                field: 'actions',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: "5px" }, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Ver detalles" }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ color: "default", onClick: function () { return handleShowDetail(row); } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Visibility, {}) })) })) })));
                                },
                            },
                        ] }), (0, jsx_runtime_1.jsx)(components_1.TablePaginationComponent, { total: (merchantsData === null || merchantsData === void 0 ? void 0 : merchantsData.data) ? merchantsData === null || merchantsData === void 0 ? void 0 : merchantsData.metadata.pagination.total : 0 })] }), searchParams.get('merchantIdentifier') && ((0, jsx_runtime_1.jsx)(containers_1.DrawerMerchantDetailContainer, { open: disclosureMerchantDetailDrawer.isOpen, onClose: handleCloseMerchantDetailDrawer, onOpen: disclosureMerchantDetailDrawer.onOpen }))] }));
}
exports.default = MerchantList;
